import t from "@emotion/styled/base";
function e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const b = /* @__PURE__ */ t("div", process.env.NODE_ENV === "production" ? {
  target: "e8prp60"
} : {
  target: "e8prp60",
  label: "DateInputFieldContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1656rwf",
  styles: "input{min-width:90px;}"
} : {
  name: "1656rwf",
  styles: "input{min-width:90px;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvRGF0ZVBpY2tlcnMvSW5wdXQvRGF0ZUlucHV0RmllbGQuc3R5bGVkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVpRCIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9wYXJ0b28tdWkvcGFydG9vLXVpL3BhY2thZ2VzL3VpL3NyYy9jb21wb25lbnRzL0RhdGVQaWNrZXJzL0lucHV0L0RhdGVJbnB1dEZpZWxkLnN0eWxlZC50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuZXhwb3J0IGNvbnN0IERhdGVJbnB1dEZpZWxkQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgICBpbnB1dCB7XG4gICAgICAgIG1pbi13aWR0aDogOTBweDtcbiAgICB9XG5gO1xuIl19 */",
  toString: e
});
export {
  b as DateInputFieldContainer
};
